<template>
  <div id="HelloWord">
	<Header2 v-if="!logueado " />
    <HelloWorld v-if="logueado" />
    <Hero v-if="!logueado" />
	
    <ProFeatures v-if="!logueado" />
	<PortfolioText v-if="!logueado" />
	<Portfolio v-if="!logueado" />
    <Catalogo v-if="!logueado" />
    <Features v-if="!logueado" />
    <Affiliates v-if="!logueado" />
    <Stats v-if="!logueado" />
    
    <Contacto v-if="!logueado" />
  </div>
</template>


<script>
const Header2 = () => import('../components/Header2.vue')
const HelloWorld = () => import('../components/HelloWorld.vue')
const Hero = () => import('../components/Hero.vue')
const ProFeatures = () => import('../components/ProFeatures.vue')
const PortfolioText = () => import('../components/portfolio/PortfolioText.vue')
const Portfolio = () => import('../components/portfolio/Portfolio')
const Features = () => import('../components/Features.vue')
const Stats = () => import('../components/Stats.vue')
const Affiliates = () => import('../components/Affiliates.vue')
const Catalogo = () => import('../components/Catalogo.vue')
const Contacto = () => import('../components/Contacto.vue')


export default {
  name: 'Home',
  components: {
	Portfolio,
	PortfolioText,
	Header2,
    HelloWorld,
    Hero,
    ProFeatures,
    Features,
    Contacto,
    Affiliates,
    Catalogo,
    Stats,
  },

  
	computed:{
		logueado(){
			return this.$store.state.usuario;
		},
	},
};
</script>
